import React from "react";
import {Badge} from "antd";
import {green} from "@ant-design/colors";

const ActiveBadge: React.FC<{isActive: boolean | number}> = ({isActive}) => {
    return <span style={{marginLeft: "5px"}}>{isActive ? <Badge color={green[4] || "Red"} status={"success"} count={"공개"} /> : <Badge count={"비공개"} />}</span>
}

export default ActiveBadge